import type { GetDesignTypesResponse } from "@nlc/shared-types";

import { useQuery } from "@tanstack/react-query";

import { designTypesKeys } from "@/hooks/queryKeys";
import { useGetCurrentProjectId } from "@/hooks/useGetCurrentProjectId";
import apiClient from "@/lib/api/client";

/** Name of the request's design type, or "" until it is known. */
export function useDesignTypeName(designTypeId?: number): string {
  const projectId = useGetCurrentProjectId();

  const { data } = useQuery<GetDesignTypesResponse, Error, string>({
    enabled: Boolean(projectId && designTypeId),
    queryFn: async () =>
      await apiClient.url(`/design-types/picker/${projectId}`).get().json(),
    queryKey: designTypesKeys.designTypesByProjectId(projectId),
    select: (response) =>
      response.designTypes.types.find((type) => type.id === designTypeId)
        ?.name ?? "",
  });

  return data ?? "";
}
